import React, { Component } from 'react';
import { SingleSourceOfTruth } from '@philips-internal/oswald-ui-core/lib/single-source-of-truth.js';
import { noop } from '@philips-internal/oswald-ui-utils';
import { EngineContext } from '../../contexts/engine-context.js';
import { fireComponentEvent, getEngineComponent, getInstanceUUID, getRoot } from '../bridge-commons.js';
import { PropsManager } from '../props-manager.js';
/**
 * A real instance of SSOT is going to be provided in PropsManager,
 * this one is necessary to TS works properly.
 */
const DUMMY_SSOT = new SingleSourceOfTruth('', {}, []);
function createClassBridgeComponent(name, StatefulComponentType, metadata) {
    var _a;
    return _a = class ClassBridgeComponent extends Component {
            constructor() {
                super(...arguments);
                this.unsubscribeFromSSOT = noop;
                this.onSSOTPropsUpdate = () => {
                    this.forceUpdate();
                };
            }
            // @ts-ignore
            static get name() {
                return name;
            }
            static get propTypes() {
                return metadata?.getPropTypes() ?? StatefulComponentType.propTypes;
            }
            componentDidMount() {
                const component = this.getEngineComponent();
                const ssot = component.getSSOT();
                this.unsubscribeFromSSOT = ssot.subscribeToProps(this.onSSOTPropsUpdate);
                fireComponentEvent(component, 'onMount');
            }
            componentWillUnmount() {
                if (this.unsubscribeFromSSOT) {
                    this.unsubscribeFromSSOT();
                }
                fireComponentEvent(this.getEngineComponent(), 'onUnmount');
                this.getRoot().discard(this.props.uuid, this.getInstanceUuid(), this.context.parent);
            }
            getEngineComponent() {
                return getEngineComponent(this.props, this.context);
            }
            getRoot() {
                return getRoot(this.context);
            }
            getInstanceUuid() {
                return getInstanceUUID(this.props, this.context);
            }
            render() {
                // Remove props that we don't want to pass down to be managed;
                // eslint-disable-next-line
                const { children, onMount, onUnmount, ssot, uuid, ...otherProps } = this.props;
                const component = this.getEngineComponent();
                const engineValue = {
                    ...this.context,
                    parent: component,
                    parentInstanceUUID: this.getInstanceUuid(),
                };
                return (React.createElement(EngineContext.Provider, { value: engineValue },
                    React.createElement(PropsManager, { engineComponent: component, ...otherProps },
                        React.createElement(StatefulComponentType, { ssot: DUMMY_SSOT, uuid: uuid }, children))));
            }
        },
        _a.contextType = EngineContext,
        _a.formatPrettyValue = StatefulComponentType.formatPrettyValue,
        _a;
}
export { createClassBridgeComponent, };
//# sourceMappingURL=class-bridge.js.map